import { render, staticRenderFns } from "./FlagItaly.vue?vue&type=template&id=da05f194&"
import script from "./FlagItaly.vue?vue&type=script&lang=js&"
export * from "./FlagItaly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports